import React, { lazy } from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const IMG = 'https://cdn.magicpatterns.com/uploads/qAdcnA19zq2jRkKqM7oszS/confianza_y_garantia_.webp';
export function GuaranteeSection() {
  return <section className="w-full bg-white py-20 sm:py-28" data-id="element-57" data-mp="9t1lj1da838w">
      <div className="mx-auto grid max-w-6xl items-center gap-12 px-4 sm:px-6 lg:grid-cols-2 lg:gap-16" data-id="element-58" data-mp="etpngi31u4hw">
        <Reveal data-id="element-59" data-mp="jtbxyjrht6n0">
          <div className="mx-auto max-w-sm overflow-hidden rounded-3xl shadow-xl shadow-rosa/15" data-id="element-60" data-mp="jrr3eu56hnp5">
            <img src={IMG} alt="Manos sosteniendo una delicada flor rosa, símbolo de cuidado y confianza" className="h-full w-full object-cover" loading="lazy" data-id="element-61" data-mp="nst4zhmkibua" />
          </div>
        </Reveal>

        <Reveal delay={0.1} data-id="element-62" data-mp="12jk0azndbt25">
          <span className="inline-flex h-16 w-16 items-center justify-center rounded-2xl bg-dorado/15 text-dorado" data-id="element-63" data-mp="12kbjfazs3ybj">
            <ShieldCheckIcon className="h-8 w-8" strokeWidth={1.5} data-id="element-64" data-mp="17id2hvx7fxn0" />
          </span>
          <h2 className="mt-6 font-serif text-3xl font-semibold text-tinta sm:text-4xl lg:text-5xl" data-id="element-65" data-mp="25sq78zum6b5i">
            Tu transformación está garantizada
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-tinta/75" data-id="element-66" data-mp="1vt7q0r6393h5">
            Quiero que empieces desde la calma, no desde la duda. Por eso tienes{' '}
            <strong className="font-semibold text-tinta" data-id="element-67" data-mp="1rtyvvl74z3l2">
              7 días de garantía de satisfacción
            </strong>
            . Si entras, sigues los primeros días y sientes que este método no
            es para ti, te devolvemos tu dinero. Así de simple.
          </p>
          <p className="mt-4 text-lg leading-relaxed text-tinta/75" data-id="element-68" data-mp="2er26trdgkja3">
            Tú solo tienes que dar el primer paso. El riesgo lo asumo yo, porque
            confío en lo que este acompañamiento puede hacer por ti.
          </p>
        </Reveal>
      </div>
    </section>;
}